"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
const react_1 = __importDefault(require("react"));
const index_1 = require("../index");
const Label_style_1 = require("./Label.style");
function Label({ children, style = [] }) {
    return react_1.default.createElement(index_1.Text, { style: [...[Label_style_1.styles.label], ...style] }, children);
}
exports.Label = Label;
